import { useJwtToken, useLoginStatus } from "@website/hooks/auth-manager";
import { useUserAgent } from "@website/hooks/user-agent";
import { useViewPort } from "@website/hooks/viewport";
import { LoginStatus } from "@website/store/store";
import { LoginModal } from "@website/widget/login";
import { FC, memo } from "react";
import { HeaderWrapper } from "..";
import { Navbar } from "../navbar";
import styles from "./layout.module.scss";
import { LayoutPropertiesType } from "./layout.types";

const Layout: FC<LayoutPropertiesType> = (properties) => {
  const { children } = properties;
  const { isDesktop } = useViewPort();
  const { isIOS } = useUserAgent();
  const { profileType } = useJwtToken();

  const isB2b = profileType === "B2B";
  const { loginStatus } = useLoginStatus();
  const shouldRenderChildren = loginStatus !== LoginStatus.Pending;
  return (
    <div className={`${styles[isIOS ? "ios-container" : "container"]}`}>
      <HeaderWrapper showAuth={true} />
      <div
        className={`w-full flex-1 gap-6 px-0 lg:flex lg:px-6 lg:pt-4 ${
          isB2b ? "xl:px-10" : "xl:mx-auto xl:w-[1200px]"
        } xl:px-0`}
      >
        <Navbar />
        {shouldRenderChildren && children}
      </div>
      {!isDesktop && <LoginModal />}
    </div>
  );
};
const LayoutMemoized = memo(Layout);
export { LayoutMemoized as Layout };
